/** angular */
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { BydUserAccount } from '@sixense/byd-auth-service';
import { Observable } from 'rxjs';
/** end angular */

/** sixense */
import { DsUserService } from '../services/ds-user.service';
/** end sixense */

@Injectable({
  providedIn: 'root',
})
export class BydUserResolver implements Resolve<BydUserAccount> {
  /**
   * Creates an instance of BydUserResolver.
   *
   * @param authService The auth service
   * @param dsUserService the map service
   */
  constructor(private dsUserService: DsUserService) {}

  /**
   * Get the getMaps by project id.
   *
   * @param route the snapshot of the route associated
   * @returns Observable<BydUserAccount>
   */
  resolve(): Observable<BydUserAccount> {
    return this.dsUserService.getUser();
  }
}
